import React from 'react';
import NavBar from './NavBar';
import { Box, ThemeProvider } from '@mui/material';
import DrawerExtend from './Common/DrawerExtend';
import { customTheme } from '../utils';
import { useOnlineStatus, useIsDesktop } from '../hooks';

const Layout = ({
  logout,
  newInstance,
  children,
  showDemoVideo,
  renderAlert,
  alertText,
  alertType,
  setAlert,
  customAlertStyle,
}) => {
    const isOnline = useOnlineStatus();
    const isDesktop = useIsDesktop();

    // Match the desktop nav drawer's presence: 12vw indent at/above 800px,
    // flush to the edge below it (no drawer is rendered there). US 14628.
    const childrenStyle = {
        flexGrow: 1,
        p: { xs: 0, md: 2, lg: 3 },
        position: 'relative',
        marginLeft: isDesktop ? '12vw' : 0
    };

    return (
        <ThemeProvider theme={customTheme}>
            <NavBar
                logout={logout}
                newInstance={newInstance}
                showDemoVideo={showDemoVideo}
                renderAlert={renderAlert}
                alertText={alertText}
                alertType={alertType}
                setAlert={setAlert}
                customAlertStyle={customAlertStyle}
                isOnline={isOnline}
            />
            <DrawerExtend />
            <Box
                component="main"
                sx={childrenStyle}
                className={isOnline ? '' : 'offlineOverlay'}
            >
                {children}
            </Box>
        </ThemeProvider>
    );
};

export default Layout;
